import Vuex from 'vuex'
import Vue from 'vue'
import patho_opd_job_worklist from "./modules/patho_opd_job_worklist";
import master_data from "./modules/master_data";
import opd_target from "./modules/opd_target";
import listoflab_opdtarget from "./modules/listoflab_opdtarget";
import lab_target from "./modules/lab_target";
import orders from "./modules/orders";
import home from "./modules/home";
import myjobstray from "./modules/myjobstray";
import admin from "./modules/admin";
import specimens from "./modules/specimens";
import listof_historyorders from "./modules/listof_historyorders";
import imr from "./modules/imr";
import pcr from "./modules/pcr";
import bact from "./modules/bact";
import orga from "./modules/orga";
import mytemplateTxt from "./modules/mytemplateTxt";
import worklist from './modules/worklist'
import web_log1  from './modules/web_log1';
import images_of_month from './modules/images_of_month' 
import parasite from './modules/parasite'
import patho_items from  './modules/patho_items'
import patho_invoice from './modules/patho_invoice';
import searchopd_for_general from './modules/searchopd_for_general'
import lab_news_element from './modules/lab_news_element'
import differentialCounterLog from './modules/differentialCounterLog'

// import createPersistedState from "vuex-persistedstate";


import manually_create_lab_automate from './modules/manually_create_lab_automate'

Vue.use(Vuex)

export default new Vuex.Store({

    modules: {
        master_data,
        opd_target,
        listoflab_opdtarget,
        lab_target,
        orders,
        home,
        myjobstray,
        admin,
        specimens,
        listof_historyorders,
        imr,
        pcr,
        bact,
        orga,
        mytemplateTxt,
        worklist ,
        manually_create_lab_automate,
        web_log1,
        images_of_month,
        parasite,
        patho_opd_job_worklist,
        patho_items,
        patho_invoice,
        searchopd_for_general,
        lab_news_element,
        differentialCounterLog,
    },
    // plugins: [createPersistedState()]


})

